import {Link} from "react-router-dom";
import "../styles/footer.scss"

export const GoForwardFooter = ({folderName, heading, link}) => {
    return (
        <footer className="gf-footer">
            <Link to={`/${link}`} className="gf-footer__wrapper">
                <p>{heading}</p>
                <p>View More</p>
                <img src={`${folderName}/Footer.jpg`} alt="#"/>
            </Link>

            <img className="gf-footer__arrow" src="arrow_bold.svg" alt="#"/>
        </footer>
    )
}